export type Pending = { pending: true };
export const isPending = (v: unknown): v is Pending => typeof v === "object" && v !== null && (v as Pending).pending === true;

/** Returns the URL string only for parseable http(s) URLs; otherwise null. */
export function safeHref(value: unknown): string | null {
  if (typeof value !== "string" || !value) return null;
  try {
    const u = new URL(value);
    return u.protocol === "http:" || u.protocol === "https:" ? value : null;
  } catch { return null; }
}

export function PendingBadge() {
  return <span className="inline-flex rounded bg-amber-100 px-1.5 py-0.5 text-xs font-medium text-amber-800">Pending verification</span>;
}

export function Field({ label, value, origin }: { label: string; value: unknown; origin?: "federal" | "state" }) {
  return (
    <div>
      <div className="label">{label}{origin === "state" && <span className="ml-1 normal-case text-brand-600">· state</span>}</div>
      {isPending(value) ? <PendingBadge />
        : value === null || value === undefined || value === "" ? <span className="text-sm text-slate-400">Not listed</span>
        : <p className="whitespace-pre-line text-sm">{String(value)}</p>}
    </div>
  );
}
